import React from 'react';
import { Box, IconButton } from '@mui/material';
import { useNavigate } from 'react-router';
import Logo from 'assets/logo.svg?react';
import AccountLogo from 'assets/account.svg?react';
import { AccountMenu } from './AccountMenu';

/** Red top bar: logo, application title and the account menu. */
export const HeaderBar: React.FC = () => {
  const navigate = useNavigate();
  const [accountAnchor, setAccountAnchor] = React.useState<null | HTMLElement>(null);

  return (
    <header className="psf-header">
      <div className="psf-header__container">
        <Box className="psf-header__brand" onClick={() => navigate('/')} sx={{ cursor: 'pointer' }}>
          <Logo width="28" height="38" />
        </Box>

        <Box className="psf-header__title" onClick={() => navigate('/')}>
          PS-Sparen Verwaltung
        </Box>

        <div className="psf-header__actions">
          <IconButton
            onClick={(event) => setAccountAnchor(event.currentTarget)}
            size="small"
            color="inherit"
            aria-label="Benutzermenü öffnen"
            aria-haspopup="true"
            aria-expanded={accountAnchor ? 'true' : undefined}
          >
            <AccountLogo className="psf-header__account-logo" />
          </IconButton>
          <AccountMenu anchorEl={accountAnchor} onClose={() => setAccountAnchor(null)} />
        </div>
      </div>
    </header>
  );
};
